import React from 'react'
import { NavLink } from 'react-router-dom'
import { useReactiveVar, useMutation } from '@apollo/client/react'
import { user, isLoggingOut } from '@cache'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Logo from '@components/logo/logo'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import User from '@utils/storage/user'
import { toast } from 'react-toastify'
import ToastMessage from '@components/ToastMessage/ToastMessage'
import LOGOUT from '@graphql/mutations/logout'
import { t } from '@utils/translations'

function Navigation() {
  const currentUser = useReactiveVar(user)

  const [logout] = useMutation(LOGOUT, {
    onCompleted(data) {
      const message = data?.logout?.message || t('messages.loggedOut')
      User.clear()
      toast(<ToastMessage message={message} />)
    },
    onError(error) {
      const message = error?.message || t('messages.logoutError')
      toast(<ToastMessage message={message} variant='danger' />)
    }
  })

  const logoutFromAdmin = (token) => {
    const logoutUrl = new URL(Settings.OAUTH_AUTHENTICATION_URL)
    logoutUrl.pathname = '/admin_users/sign_out'

    fetch(logoutUrl.toString(), {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    }).catch((error) => {
      const message = error?.message || t('messages.logoutError')
      toast(<ToastMessage message={message} variant='danger' />)
    }).finally(() => {
      isLoggingOut(false)
    })
  }

  const handleLogout = () => {
    isLoggingOut(true)

    logout()
      .then((result) => {
        sessionStorage.removeItem('codeVerifier')

        const token = result?.data?.logout?.token

        if (!token) {
          isLoggingOut(false)
          return
        }

        logoutFromAdmin(token)
      })
      .catch((error) => {
        const message = error?.message || t('messages.logoutError')
        toast(<ToastMessage message={message} variant='danger' />)
        isLoggingOut(false)
      })
  }

  if (!currentUser) { return null }

  return (
    <Navbar aria-label='Main navigation' variant='dark'>
      <Logo />
      <Nav className='me-auto'>
        <Nav.Item>
          <NavLink to='/applications' className='nav-link'>Applications</NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to='/tokens' className='nav-link'>Tokens</NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to='/operations' className='nav-link'>Operations</NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to='/transactions' className='nav-link'>Transactions</NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to='/requests' className='nav-link'>Requests</NavLink>
        </Nav.Item>
      </Nav>
      <Navbar.Toggle />
      <Navbar.Collapse className='justify-content-end'>
        <Navbar.Text>
          <Button
            className='logout'
            variant='link'
            onClick={handleLogout}
          >
            Logout
            <Badge bg='primary'>{currentUser.login}</Badge>
          </Button>
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default Navigation
